exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close[data-v-3fae258c] {\n  outline: none;\n}", ""]);

// exports
